import React, { Component } from "react";
import Logo from "../assets/logo-b.svg";
import MobileLogo from "../assets/mobile-logo.svg";
import {
  DashboardIcon,
  ProjectsIcon,
  SettingsIcon,
  UsersIcon,
} from "../assets/icons";
import { Link } from "react-router-dom";
import loginStore from "../stores/loginStore";
import { observer } from "mobx-react";
import { LuLogOut } from "react-icons/lu";
import moment from "moment";
import { GiBookCover } from "react-icons/gi";
import voiceStore from "../stores/voiceStore";
import { IoIosAddCircle } from "react-icons/io";

const Header = observer(
  class Header extends Component {
    constructor(props) {
      super(props);
      this.state = {
        employeeName: "",
      };
    }

    render() {
      return (
        <div className="flex flex-1 flex-row bg-white justify-between p-3 lg:px-9 lg:py-5 items-center filter drop-shadow-lg">
          <Link className="w-40 hidden lg:flex" to="/dashboard">
            <img
              className="w-40 hidden lg:flex"
              src={Logo}
              alt="Sounds Great"
            />
          </Link>

          <Link className="w-12 xs:flex lg:hidden" to="/dashboard">
            <img
              className="w-12 xs:flex lg:hidden"
              src={MobileLogo}
              alt="Sounds Great"
            />
          </Link>

          <div className="hidden lg:flex flex-row gap-x-8 justify-between">
            {/* <Link to="/dashboard" className='flex flex-row gap-x-2'>
                        <img className='w-6' src={DashboardIcon} alt="Dashboard" />
                        <span className='font-semibold text-base text-[#130D0D]'>Dashboard</span>
                    </Link> */}

            <Link to="/talents" className="flex flex-row gap-x-2 items-center">
              {/* <img className='w-6' src={UsersIcon} alt="Talents" /> */}
              <GiBookCover size={36} color="#0278be" />
              <span className="font-semibold text-base text-[#130D0D]">
                Talents Book
              </span>
            </Link>

            {/* <Link
              to={`/projects/${moment().year()}`}
              className="flex flex-row gap-x-2"
            >
              <img className="w-6" src={ProjectsIcon} alt="Projects" />
              <span className="font-semibold text-base text-[#130D0D]">
                Projects
              </span>
            </Link> */}
          </div>

          <div>
            <button
              onClick={() => voiceStore.changeStepperVisible(true)}
              className="flex gap-x-1 items-center"
            >
              <IoIosAddCircle
                size={36}
                style={{
                  fill: "url(#gradient)",
                }}
              />
              <svg width="0" height="0">
                <defs>
                  <linearGradient
                    id="gradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="purple" />
                    <stop offset="80%" stopColor="blue" />
                  </linearGradient>
                </defs>
              </svg>
              Add Talents
            </button>
          </div>

          <div className="flex flex-row gap-x-6 items-center">
            <Link to="/users" className="flex flex-row gap-x-2">
              <img className="w-6" src={SettingsIcon} alt="Users" />
              <span className="font-semibold text-base text-[#130D0D]">
                Users
              </span>
            </Link>
            <button
              onClick={() => {
                loginStore.logout();
              }}
              className="flex flex-row items-center gap-x-2"
            >
              <span>Logout</span>

              <LuLogOut></LuLogOut>
            </button>
          </div>
        </div>
      );
    }
  }
);

export default Header;
